
import config from '../env.js'
import axios from 'axios'
export default {
    name: 'Logout',
    data: function () {
        return {
            message: 'It is processing...'
        }
    },
    methods: {
        getApiUrl: function() {
            return (process.env.VUE_APP_ENV === 'prod' ? config.new_loginBaseUrl_prod : config.new_loginBaseUrl_uat );
        },
        logout: async function (callbackfunc) {
            localStorage.removeItem("username")
            localStorage.removeItem("lang")
            this.$store.commit('setAuthJson', {});
            console.log("logout(): cb start");

            var token = this.$cookie.get('accessToken');
            let result = await axios.get(config.logoutPath, {headers: {"Authorization": token}});
            console.log(result)
            // if(result.status == 204){
            callbackfunc();
            console.log("logout(): cb end");
            //}
            
            // this.$http.post((process.env.VUE_APP_ENV === 'prod' ? config.prd_BaseUrl : config.uat_BaseUrl) + config.logoutPath, {}).then((res) => {
            // // this.$http.post(config.uat_BaseUrl + config.logoutPath, {}).then((res) => {
            //     this.$currentUrl = this.$uat_eserviceUrl;
            //     console.log("logout(): cb start");
            //     this.$store.commit('setAuthJson', res.data);
            //     callbackfunc();
            //     console.log("logout(): cb end");
            // }, function () {
            //     console.log('logout(): fail');
            // });
        },

        callBackLogout: function () {
            this.message = 'You can close the browser now.';
            // location.href = this.$uat_eserviceUrl;
          this.$cookie.delete('accessToken', {domain: '.qhms.com'});
          this.$cookie.delete('refreshToken', {domain: '.qhms.com'});

          var redirect_url = encodeURIComponent((process.env.VUE_APP_ENV === 'prod' ? config.prd_eservice_url : (process.env.VUE_APP_ENV === 'uat' ? config.uat_eservice_url : config.test_BaseUrl)))
          location.href = this.getApiUrl() + '/spa/com/login/int_web.html#redirect_url=' + redirect_url + '&required2fa=0';
        }
    },
    mounted: async function() {
        await this.logout(this.callBackLogout);
    },
}
